export class AdditionalInfo {
  referenzMonat: string;
  referenzJahr: number;
  betriebsueblicheArbeitszeitImReferenzMonat: number;
  codierungMann: string;
  codierungFrau: string;
  genderMode: string;
  alterConfig: number;
  dienstjahreConfig: number;

  exportDatum: string;
  versionLogib: string;
  dokumentenTyp: string;
  versionDokumentenTyp: string;
}

export class AdditionalInfoM2 extends AdditionalInfo {}
